import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=40ef3bed&scoped=true"
import script from "./rightBottom.vue?vue&type=script&lang=js"
export * from "./rightBottom.vue?vue&type=script&lang=js"
import style0 from "./rightBottom.vue?vue&type=style&index=0&id=40ef3bed&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef3bed",
  null
  
)

export default component.exports